import { useState } from "react";
import Proptypes from "prop-types";
import { PageSizeContext } from "./PageSizeContext";

export const PageSizeProvider = ({ children }) => {
    const [pageSize, setPageSize] = useState({});
    console.log('[PAGE SIZE PROVIDER] Se reenderizo');

    return (
        <PageSizeContext.Provider value={{pageSize, setPageSize}}>
            {children}
        </PageSizeContext.Provider>
    );
}

PageSizeProvider.propTypes = {
    children: Proptypes.node.isRequired
}